import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-20 md:py-24 bg-foreground-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20geometric%20pattern%20with%20overlapping%20circles%20and%20flowing%20lines%2C%20minimalist%20design%2C%20dark%20charcoal%20background%20with%20subtle%20coral%20and%20amber%20accents%2C%20modern%20texture%2C%20seamless%20pattern%20style%2C%20no%20text%2C%20smooth%20gradients&width=1800&height=600&seq=cta-bg-pattern&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
          不想错过任何一个大瓜？
        </h2>
        <p className="text-sm md:text-base text-background-50/60 max-w-xl mx-auto mb-8">
          51吃瓜大赛每日更新最新爆料，网红塌房、明星黑料、热门大赛实时追踪，快来加入吃瓜大军吧
        </p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link
            to="/category/meiri-dasai"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-medium rounded-lg transition-all whitespace-nowrap cursor-pointer"
          >
            立即吃瓜
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/about"
            className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 font-medium rounded-lg border border-background-50/20 transition-all whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}